<template>
    <image-buttons :question="question" @done="$log($event)" />
</template>

<script>
import ImageButtons from "./ImageButtons";

export default {
    components: {
        ImageButtons,
    },
    props: {
        person: {
            required: true,
            type: String,
        },
    },
    computed: {
        question() {
            let result = {
                id: "be-6",
                options: [
                    {
                        value: "woman",
                        image: "woman.png",
                    },
                    {
                        value: "man",
                        image: "man.png",
                    },
                ],
            };
            if (this.person === "child") {
                result = {
                    id: "be-6",
                    options: [
                        {
                            value: "girl",
                            image: "girl.png",
                        },
                        {
                            value: "boy",
                            image: "boy.png",
                        },
                    ],
                };
            }
            return result;
        },
    },
};
</script>

<style></style>
